__turbopack_context__.v({
  "highlightBoxContent": "HighlightBox-module__uHWSrG__highlightBoxContent",
  "highlightBoxTrigger": "HighlightBox-module__uHWSrG__highlightBoxTrigger",
  "highlightBox__closeButton": "HighlightBox-module__uHWSrG__highlightBox__closeButton",
  "highlightBox__navigation": "HighlightBox-module__uHWSrG__highlightBox__navigation",
  "pulsatingDot": "HighlightBox-module__uHWSrG__pulsatingDot",
  "pulse": "HighlightBox-module__uHWSrG__pulse",
});
